import {create} from 'zustand';
import {persist} from 'zustand/middleware';

const userStore = (set) => ({
  user: null,
  setCredentials: (user) => set({user}),
  removeCredentials: () => set({user: null}),
});

const persistedUserStore = persist(userStore, {
  name: 'user',
});

export const useUserStore = create(persistedUserStore);
